import { nsHistorics } from '@/app/i18n/namespaces';
import Entity from '@/common-utils/components/renders/entity/Entity';
import TooltipHelper from '@/common-utils/components/renders/tooltip/TooltipHelper';
import ICONS from '@/common-utils/enums/icons';
import PropTypes from 'prop-types';

/**
 *
 * @param {Object} props - Props object
 * @param {Object} props.cellData - Cell data object
 * @returns {JSX} RenderUserInitiator
 */
function RenderUserInitiator({ cellData }) {

    // Constants
    const userInitiator = cellData.origin ?? null;
    const userAccountUpdated = cellData.current ?? null;

    // Render on error
    if (!userInitiator || !userAccountUpdated) {
        return <Entity entity='cells.no_user' namespace={nsHistorics} />;
    }

    // Render if same user
    if (userInitiator === userAccountUpdated) {
        return (
            <TooltipHelper triggerClass='text-left w-fit max-w-48'
                trigger={<Entity
                    className='block whitespace-nowrap overflow-hidden text-ellipsis max-w-full'
                    entity={userInitiator}
                />}
                content={<Entity entity={userInitiator} />}
            />
        );
    }

    // Render if not same user
    return (
        <TooltipHelper triggerClass='text-left w-fit max-w-48'
            trigger={
                <div className='flex items-center flex-col'>
                    <Entity
                        className='block whitespace-nowrap overflow-hidden text-ellipsis max-w-full'
                        entity={userInitiator}
                    />
                    <Entity entity={userAccountUpdated} icon={ICONS.USER_CONNECT_AS} className='text-xs' />
                </div>
            }
            content={
                <Entity
                    entity='tooltip.user_initiator'
                    data={{ userInitiator: userInitiator, userAccountUpdated: userAccountUpdated }}
                    namespace={nsHistorics}
                />
            }
        />
    );
}
RenderUserInitiator.propTypes = {
    cellData: PropTypes.object
};
export default RenderUserInitiator;